import { Component } from "@angular/core";
import {
  AlertController,
  IonicPage,
  NavController,
  NavParams,
} from "ionic-angular";
import { Api } from "../../services/api";
import { Util } from "../../services/util";
import { sharedData } from "../../services/vars";
import { User } from "../../services/user";
import { Purchase } from "../../services/purchase";
import { BindAccountPage } from "../bind-account/bind-account";
import { ShareCard } from "../../services/sharecard";

/**
 * Generated class for the ItemDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "item/:id",
})
@Component({
  selector: "page-item-detail",
  templateUrl: "item-detail.html",
})
export class ItemDetailPage {
  item;
  carouselImages = [];
  firstOrganizerSpecialCashRewards = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private api: Api,
    private util: Util,
    private user: User,
    private purchase: Purchase,
    private alertCtrl: AlertController,
    private shareCard: ShareCard
  ) {}

  viewMyCampaign() {
    window.location.hash = "/campaign/" + this.item.my_campaign_id;
  }

  isItemExpired() {
    if (!this.item.group_buy_mode_expire_time) {
      return false;
    } else {
      return +new Date() > this.item.group_buy_mode_expire_time;
    }
  }

  createMyCampaign(solo = false) {
    if (!window["UserService"].isLoggedIn()) {
      window["UserService"].showLogin();
      return;
    }
    if (!window["UserService"].user_center_user_id) {
      this.util.showToast("请先完成手机号绑定，再进行购买");
      window["bindAccountCallback"] = () => {
        this.createMyCampaign(solo);
      };
      this.navCtrl.push(BindAccountPage);
      return;
    }
    if (this.item.campaign_type === 0) {
      // 砍价活动直接跳转
      this.api
        .createCampaign({
          itemId: this.item.id,
        })
        .then((campaign) => {
          sharedData.showCampaignCreatedFlag = true;
          sharedData.showShareGuideFlag = true;
          window.location.hash = "/campaign/" + campaign.id;
        });
    } else {
      const isGroupBuy = this.item.campaign_type === 1;
      const isDescendingGroupBuy = this.item.campaign_type === 2;
      const isGlobalGroupBuy = this.item.campaign_type === 3;
      if (isGroupBuy || isDescendingGroupBuy || isGlobalGroupBuy) {
        // 拼团活动先付款
        if (this.item.my_campaigns && this.item.my_campaigns.length) {
          this.util
            .confirm(
              `您已经参与了${
                this.item.my_campaigns.length
              }个活动了，确定要重新发起新的活动吗？${
                isGroupBuy && !solo
                  ? "<br/>发起后，您将是团长，需要在时间期限内邀请足够数量的朋友加入。"
                  : ""
              }`,
              "请确认"
            )
            .then((res) => {
              if (res) {
                this.purchase.joinGroupBuy(
                  this.item.id,
                  0,
                  false,
                  isDescendingGroupBuy,
                  isGlobalGroupBuy,
                  null,
                  solo
                );
              } else {
                this.alertCtrl
                  .create({
                    title: "提示",
                    subTitle:
                      "您可以点击右下角用户图标来查看您已经参加过的拼团活动。",
                    buttons: [
                      {
                        text: "好",
                        role: "cancel",
                      },
                    ],
                  })
                  .present();
              }
            });
        } else {
          (solo || this.item.campaign_type === 3
            ? Promise.resolve(true)
            : this.util.confirm(
                `确定要发起新的拼团活动吗？<br/>${
                  isGroupBuy
                    ? "发起后，您将是团长，需要在时间期限内邀请足够数量的朋友加入。"
                    : "发起后，您将是团长，邀请越多的朋友加入，商品单价越低。"
                }`,
                "请确认"
              )
          ).then((res) => {
            if (res) {
              this.purchase.joinGroupBuy(
                this.item.id,
                0,
                false,
                isDescendingGroupBuy,
                isGlobalGroupBuy,
                null,
                solo
              );
            } else {
              this.alertCtrl
                .create({
                  title: "提示",
                  subTitle:
                    "如果您想加入别人发起的团，请通过他们分享的链接进行付款。",
                  buttons: [
                    {
                      text: "好",
                      role: "cancel",
                    },
                  ],
                })
                .present();
            }
          });
        }
      }
    }
  }

  ionViewDidLoad() {
    this.api.collect({
      event: "view-item",
      attr: { id: this.navParams.data.id },
    });
  }

  getDesc() {
    if (this.item.campaign_type === 2) {
      return "拼团";
    } else if (this.item.campaign_type === 1) {
      return "拼团";
    } else if (this.item.campaign_type === 3) {
      return "优惠";
    } else {
      return "砍价";
    }
  }

  private setWeixinShareMessage() {
    this.shareCard.share({
      title: this.item.name + " - " + this.getDesc() + "活动",
      desc: this.item.name + " 商品详情",
      link: location.href,
      imgUrl: this.item.image_url,
    });
  }

  ionViewDidEnter() {
    if (!this.item) {
      document.title = "加载中……";
    } else {
      document.title = this.item.name + " - " + this.getDesc() + "活动";
      this.setWeixinShareMessage();
    }

    this.api.getItemDetail(this.navParams.data.id).then((item) => {
      if (window["UserService"].isLoggedIn() && item.solo_price > 0) {
        this.api.getDiscountedSoloPrice(item.id).then((data) => {
          if (data.price !== item.solo_price) {
            item.discounted_solo_price = data.price;
          }
        });
      }

      if (item.descending_price_specs) {
        item.descendingPriceSpecs = JSON.parse(item.descending_price_specs);
        item.descendingPriceSpecs.unshift({ at: 0, price: item.price });
      }
      if (item.organizer_special_cash_rewards) {
        item.organizerSpecialCashRewards = JSON.parse(
          item.organizer_special_cash_rewards
        );
      }

      if (item.organizerSpecialCashRewards) {
        item.organizerSpecialCashRewards.forEach((item) => {
          if (item.number_from === 1) {
            this.firstOrganizerSpecialCashRewards = item;
          }
        });
      }

      this.item = item;
      if (this.item.price - this.item.max_price_cut === this.item.solo_price) {
        this.item.solo_price_same_as_group_buy = true;
      }
      (this.item.ongoingCampaigns || []).forEach((camp) => {
        camp.group_buy_wanted_participants_count =
          item.group_buy_mode_participants_required -
          camp.group_buy_paid_participants_count;
      });
      this.carouselImages = this.util.getCarouselImages(
        item.image_url,
        item.carousel_images
      );
      document.title = item.name + " - " + this.getDesc() + "活动";
      this.setWeixinShareMessage();
    });
  }

  joinExistingCampaign(campaign) {
    window.location.hash = "/campaign/" + campaign.id;
  }
}



// WEBPACK FOOTER //
// ./src/pages/item-detail/item-detail.ts